(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-maca-root]').forEach(root => {
      if (root.dataset.macaReady) return;
      root.dataset.macaReady = 'true';
      const submit = root.querySelector('[data-maca-submit]');
      const originalLabel = submit.textContent.trim();
      function update() {
        const option = root.querySelector('[data-maca-variant]:checked');
        if (!option) return;
        const price = Number(option.dataset.price);
        const available = option.dataset.available === 'true';
        const formatted = new Intl.NumberFormat('es-PE', {style:'currency',currency:window.Shopify?.currency?.active || 'PEN'}).format(price / 100);
        root.querySelectorAll('[data-maca-price]').forEach(el => el.textContent = formatted);
        root.querySelector('[data-maca-option]').textContent = option.dataset.title === 'Default Title' ? '1 frasco' : option.dataset.title;
        submit.disabled = !available;
        submit.textContent = available ? (originalLabel === 'Agotado' ? 'Agregar a mi pedido' : originalLabel) : 'Agotado';
      }
      root.addEventListener('change', e => {if (e.target.matches('[data-maca-variant]')) update();});
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
